/**
 * API Interface
 *
 * @requires Vue
 * @requires Axios
 */

// Dependencies
import axios from 'axios'
import crypto from 'crypto'

// Config
import config from '@/../config/app.json'

// Helpers
const isObject = function (a) {
	return Object.prototype.toString.call(a) === '[object Object]' && a.constructor.name === 'Object'
}

const settings = JSON.parse(localStorage.getItem('settings') || '{"devMode":"false"}')
const doCache = !settings.devMode

// API
const api = {

	_buildObject(obj) {
		const key = Object.keys(obj)[0]
		obj = obj[key]
		let where = ``
		let fields = ``

		if (obj.where) {
			where += `(`
			const keys = Object.keys(obj.where)
			const wheres = []
			for (const key of keys) {
				const val = obj.where[key]
				wheres.push(`${key}:"${val}"`)
			}
			where += wheres.join(',')
			where += `)`
		}

		if (obj.fields) {
			const fields_ = []
			for (const field of obj.fields) {
				if (isObject(field) || typeof field === 'object') {
					fields_.push(this._buildObject(field))
				} else {
					fields_.push(field)
				}
			}
			fields = fields_.join(' ')
		}

		const qs = `${key} ${where} { ${fields} }`
		return qs
	},

	request(params) {
		const query = this._buildObject(params)
		const qs = `query {${query}}`

		const key = crypto.createHash('sha256').update(JSON.stringify(query)).digest('base64')

		const cached = sessionStorage.getItem(key)
		if (!cached || !doCache) {
			return new Promise((resolve, reject) => {
				axios({
					method: 'post',
					url: config.app.apiUrl,
					data: {
						query: qs,
					},
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${config.app.apiKey}`,
					},
				}).then(res => {
					if (res.data.data) {
						resolve(res.data.data)
						sessionStorage.setItem(key, JSON.stringify(res.data.data))
					} else {
						reject(new Error('No data found'))
					}
				})
					.catch(err => {
						reject(err)
					})
			})
		}
		return Promise.resolve(JSON.parse(cached))
	},
}

export default api



// WEBPACK FOOTER //
// ./src/lib/api/index.js